import { StarOutlined } from '@ant-design/icons';
import { List } from 'antd';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { Address } from 'store/models/user.model';
import styles from './style.module.scss';

type AddressListItemProps = {
  item: Address;
  actions?: React.ReactNode[];
  selected: boolean;
};

const AddressListItem: React.FC<AddressListItemProps> = ({ item, actions, selected }) => {
  const titleItem = useMemo(
    () => (
      <div className={styles['address-title-container']}>
        <h2 className={styles['address-title']}>
          {selected && <StarOutlined />} {item.neighborhood}
        </h2>
      </div>
    ),
    [item.neighborhood, selected],
  );

  const descriptionList = useMemo(() => {
    const { state, city, neighborhood, streetNumber, blockNumber, street } = item;
    return (
      <p>
        {state && `${state}, `}
        {city && `${city}, `}
        {neighborhood && `${neighborhood}, `}
        {street && `${street} `}
        {streetNumber && `${streetNumber}, `}
        {blockNumber && `${blockNumber}.`}
      </p>
    );
  }, [item]);

  return (
    <List.Item actions={actions} className={styles['addres-item-container']}>
      <List.Item.Meta
        className={clsx(styles['addres-item'], selected && styles['selected'])}
        title={titleItem}
        description={descriptionList}
      />
    </List.Item>
  );
};

export default AddressListItem;
